import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Dropdown from "../../components/commalax/dropdown";
import ProductCard from "../../components/commalax/product_card";
import {
  adminCollections,
  carenelCategories,
  cleanser,
  innisfreeCategories,
  JMsolutionCategories,
  lipcare,
  maskpack,
  serum,
  skincare,
  toner,
} from "../../template_codes/commalax/home_page_codes";

const ProductsPage = () => {
  const { id } = useParams();
  const [products, setProducts] = useState(null);

  useEffect(() => {
    if (id == "lipcare") {
      setProducts(lipcare);
    } else if (id == "skincare") {
      setProducts(skincare);
    } else if (id == "cleanser") {
      setProducts(cleanser);
    } else if (id == "serum") {
      setProducts(serum);
    } else if (id == "maskpack") {
      setProducts(maskpack);
    } else if (id == "toner") {
      setProducts(toner);
    }
  }, [id]);

  return (
    <>
      <div className="flex justify-center items-center py-5 bg-white">
        <ul className="mb-4 mt-2 flex flex-wrap gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6 text-black">
          <Dropdown category={"CARE:NEL"} dropdownData={carenelCategories} />
          <Dropdown category={"innisfree"} dropdownData={innisfreeCategories} />
          <Dropdown
            category={"JM solution"}
            dropdownData={JMsolutionCategories}
          />
        </ul>
      </div>
      <div className="flex justify-center items-center flex-wrap gap-5 my-5">
        {products?.map((item, i) => (
          <ProductCard key={i} item={item} />
        ))}
      </div>
    </>
  );
};

export default ProductsPage;
